import script from "./otherStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./otherStatus.vue?vue&type=script&setup=true&lang=js"

import "./otherStatus.vue?vue&type=style&index=0&id=a2c7e1da&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2c7e1da"]])

export default __exports__